import { RootAppState } from 'store/configureStore'

export const bomItemFocusedItemsSelector = (state: RootAppState) => {
  return state.project.focusedBomItemId
}

export const bomItemIsFocusedSelector =
  (bomItemId: string) => (state: RootAppState) => {
    return state.project.focusedBomItemId === bomItemId
  }
